<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12 col-md-12">
            <div class="card h-100">
                <div class="card-header">
                    <div class="btn-group float-end" role="group" *ngIf="level==99">
                        <button  class="btn  btn-primary" (click)="openModal(add)"><i class="fa-solid fa-circle-plus"></i>
                            </button>
                    </div>
                </div>
                <div class="card-body">
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table user-list">
                            <thead>
                                <tr>
                                    <th><span>NOMBRE</span></th>
                                    <th><span>RUT</span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of items">
    
                                    <td>
                                        <span>{{item.name | uppercase}}</span>
                                        &nbsp;
                                      <span>{{item.lastname | uppercase}}</span>
                                  </td>
                                    <td>
                                        <span>{{item.rut | uppercase}}</span>
                                    </td>
                                    <td>
                                        <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                                          <button type="button" class="btn   text-warning"
                                                (click)="openEdit(item,edit)">
                                                    <i class="fa fa-pencil" *ngIf="level==99"></i>
                                                    <i class="fa-regular fa-eye" *ngIf="level<99"></i>
                                            </button>
                                            <button *ngIf="level==99" type="button" class="btn  text-danger"
                                                (click)="openDelete(item,remove)">
                                                    <i class="fa-solid fa-trash"></i>  
                                            </button>
                                        </div>
  
                                    </td>
                                </tr>
                                <tr *ngIf="!items">
                                    <td colspan="7" class="fw-lighter text-muted">No se encontraron registros</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
  
  </div>
  <ng-template #remove let-c="close" let-d="dismiss">

        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Eliminar registro</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>¿Esta seguro que desea eliminar este registro?</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">No</button>
            <button type="button" ngbAutofocus class="btn btn-danger" (click)="delete()">Si</button>
        </div>

  </ng-template>
  
  <ng-template #add let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
          <app-add-users [storesId]="storesId"  (success)="get()"/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
  </ng-template>
  
  
  <ng-template #edit let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
          <app-edit-users [users]="selected" (success)="get()"/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
  </ng-template>
